export const FULL_TIME_DATE_PT_BR = `dd/MM/yyyy 'ás' HH:mm`
